import React from 'react';
import TicketViewUserContent from './TicketViewUserContent';

/**
 * TicketViewUser (Active View / Presentation)
 * Pure Presentation Component.
 * Receives `ticket` guaranteed from TicketRoute.
 */
const TicketViewUser = ({ ticket, isStaff = false }) => {
  return <TicketViewUserContent ticket={ticket} isStaff={isStaff} />;
};

export default TicketViewUser;
